import { useEffect } from "react";
import {
  Box,
  Flex,
  HStack,
  IconButton,
  Image,
  useDisclosure,
  useColorModeValue,
  Stack,
  Text
} from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import { COLORS } from "../../../colors";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const location = useLocation();



  return (
    <>
      <Box bg="#fffff" px={4} fontFamily={'Montserrat'} >
        <Flex h={16} alignItems={"center"} justifyContent={"space-between"}>
        <Flex flex={1}>
            <Link to="/">
              <Image
                alt={'Logo Image'}
                objectFit={'scale-down'}
                src={"/Somerset-logo.png"}
              />
            </Link>
          </Flex>

          <Flex h={16} alignItems={"center"}>
            {(location.pathname === '/' || location.pathname === '/opiniones' || location.pathname === '/contact' || location.pathname === '/cursos' || location.pathname === '/cursos/primaria' || location.pathname === '/cursos/eso_bachiller' || location.pathname === '/cursos/adultos' || location.pathname === '/cursos/intensivo') && <IconButton
              size={"md"}
              icon={isOpen ? <CloseIcon color={COLORS.brand1}/> : <HamburgerIcon color={COLORS.brand1}/>}
              aria-label={"Open Menu"}
              display={{ md: "none" }}
              onClick={isOpen ? onClose : onOpen}
              bg={"transparent"}
              color={COLORS.brand4}
            />}
            {(location.pathname === '/' || location.pathname === '/opiniones' || location.pathname === '/contact' || location.pathname === '/cursos' || location.pathname === '/cursos/primaria' || location.pathname === '/cursos/eso_bachiller' || location.pathname === '/cursos/adultos' || location.pathname === '/cursos/intensivo') && <HStack spacing={8} alignItems={"center"}>
              <HStack
                as={"nav"}
                spacing={4}
                display={{ base: "none", md: "flex" }}
              >
                <Link to="/cursos">Cursos</Link>
              </HStack>
              <HStack
                as={"nav"}
                spacing={4}
                display={{ base: "none", md: "flex" }}
              >
                <Link to="/opiniones">Opiniones</Link>
              </HStack>
              <HStack
                as={"nav"}
                spacing={4}
                display={{ base: "none", md: "flex" }}
              >
                <Link to="/contact">Contacto</Link>
              </HStack>
              <HStack
                as={"nav"}
                spacing={4}
                display={{ base: "none", md: "flex" }}
              >
                
              </HStack>
            </HStack>}
          </Flex>
        </Flex>

        {isOpen ? (
          <Box pb={4} display={{ md: "none" }} pt={4}>
            <Stack as={"nav"} spacing={4} textAlign={"right"}>
              <Link to="/cursos">Cursos</Link>
            </Stack>
          </Box>
          
        ) : null}
         {isOpen ? (
          <Box pb={4} display={{ md: "none" }} pt={4}>
            <Stack as={"nav"} spacing={4} textAlign={"right"}>
              <Link to="/opiniones">Opiniones</Link>
            </Stack>
          </Box>
          
        ) : null}
                 {isOpen ? (
          <Box pb={4} display={{ md: "none" }} pt={4}>
            <Stack as={"nav"} spacing={4} textAlign={"right"}>
              <Link to="/contact">Contacto</Link>
            </Stack>
          </Box>
          
        ) : null}
                  {isOpen ? (
          <Box pb={4} display={{ md: "none" }} pt={4}>
            <Stack as={"nav"} spacing={4} textAlign={"right"}>
              
            </Stack>
          </Box>
          
        ) : null}
      </Box>
    </>
  );
}
